import { googleAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import authPlugin from '@backstage/plugin-auth';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import jenkinsPlugin from '@backstage-community/plugin-jenkins/alpha';
import certificatesModule from '@iqm/backstage-plugin-certificates';
import adoptionAnalyticsPlugin from '@codeverse-gp/plugin-adoption-analytics';
import adoptionAnalyticsApi from './modules/adoptionAnalyticsApi';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          provider={{
            id: 'google-auth-provider',
            title: 'Google',
            message: 'Sign in using Google',
            apiRef: googleAuthApiRef,
          }}
        />
      ),
  },
});

export default createApp({
  features: [
    authPlugin,
    catalogPlugin,
    navModule,
    homeModule,
    certificatesModule,
    jenkinsPlugin,
    adoptionAnalyticsPlugin,
    adoptionAnalyticsApi,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
